import React from 'react';
import { SHOW_LESS, SHOW_MORE } from 'common/constants/pageFilters';
import { Currency } from 'common/types/format';
import {
  PrimaryNavigationMenu,
  PrimaryNavigationMenuItem,
} from 'components/ui';
import { PrimaryNavigationMenuProps } from 'components/ui/PrimaryNavigation/PrimaryNavigation.props';

interface CurrencyMenuProps extends Pick<PrimaryNavigationMenuProps, 'data-testid'> {
  anchorEl: HTMLButtonElement | null;
  currencies: { code: string; symbol: string }[];
  isCurrencyLoading: boolean;
  onClose: () => void;
  onCurrencyChange: (currency: Currency) => void;
  showMore: () => void;
  showLess: () => void;
  usedCurrencies: string[];
}

const CurrencyMenu = ({
  anchorEl,
  currencies,
  'data-testid': dataTestId,
  isCurrencyLoading,
  onClose,
  onCurrencyChange,
  showMore,
  showLess,
  usedCurrencies,
}: CurrencyMenuProps) => (
  <PrimaryNavigationMenu
    anchorEl={anchorEl}
    data-testid={dataTestId}
    open={Boolean(anchorEl)}
    onClose={onClose}>
    {currencies.map(c => {
      const isLastUsed = c.code === usedCurrencies[usedCurrencies.length - 1];
      return (
        <PrimaryNavigationMenuItem
          key={c.code}
          disabled={isCurrencyLoading}
          sx={isLastUsed ? { borderBottom: '1px solid #EFEFEF' } : undefined}
          onClick={() => onCurrencyChange(c)}>
          {`${c.code} (${c.symbol})`}
        </PrimaryNavigationMenuItem>
      );
    })}
    <PrimaryNavigationMenuItem
      disabled={isCurrencyLoading}
      sx={{ fontSize: '0.875rem', color: 'text.secondary' }}
      onClick={currencies.length === usedCurrencies.length ? showMore : showLess}>
      {currencies.length === usedCurrencies.length ? SHOW_MORE : SHOW_LESS}
    </PrimaryNavigationMenuItem>
  </PrimaryNavigationMenu>
);

export default CurrencyMenu;
